// extracted by mini-css-extract-plugin
export default {"appWrapper":"PageLayout_appWrapper__gjVRa","appHeader":"PageLayout_appHeader__d10ik","appContent":"PageLayout_appContent__TKsb6"};